import type { ReactNode } from 'react';

import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const level2Css = css({
	margin: 0,
	textAlign: 'center',
});

const level3Css = css({
	margin: 0,
	fontFamily: 'var(--atlassian-sans-font-family)',
	fontSize: '1.25rem',
	lineHeight: '1.5rem',
	fontWeight: 700,
	color: token('color.text'),
	textAlign: 'center',
});

export type LoomOnboardingHeadingProps = {
	children: ReactNode;
	level: 2 | 3;
};

/**
 * Reusable heading for the Loom onboarding flow.
 * - levels are equal to the 'h' html tags
 */
export const LoomOnboardingHeading = ({ children, level }: LoomOnboardingHeadingProps) => {
	if (level === 2) {
		return <h2 css={level2Css}>{children}</h2>;
	}

	return (
		<div role="heading" aria-level={3} css={level3Css}>
			{children}
		</div>
	);
};
